"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrevButton = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var button_1 = require("../styled/button");

var PrevButton = function PrevButton(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      isDisabled = _a.isDisabled;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Pagination-NextPrevButton',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _b = (0, react_1.useContext)(context_1.PaginationContext),
      prevLabel = _b.prevLabel,
      currentPage = _b.currentPage,
      onChange = _b.onChange,
      totalPages = _b.totalPages,
      isInverse = _b.isInverse;

  var onClick = function onClick() {
    return onChange(currentPage < 1 ? totalPages : currentPage - 1);
  };

  return react_1.default.createElement(button_1.Button, {
    onClick: onClick,
    className: rootClasses,
    "aria-label": prevLabel,
    isInverse: isInverse,
    disabled: isDisabled
  }, react_1.default.createElement(ui_icon_1.Icon, {
    "aria-hidden": "true",
    name: "caret-left",
    title: "".concat(prevLabel, " icon"),
    isParentColor: true
  }));
};

var PrevButtonWithSpace = (0, ui_helper_with_space_1.withSpace)(PrevButton);
exports.PrevButton = PrevButtonWithSpace;